import React, { useState } from "react";
import ProductList from "../products/Productslist";
import ViewStockToolsUpdate from "./view-powertools";
import ViewSparesStockUpdate from "./view-sparestocktools";
import NotifiedList from "./notified-list";
import StockManagement from "./stockmanagement";
import ToolsStockManagement from "./tools-stockmanagement";

const tabs = [
  "Product List",
  "Product Upload",
 
  "View-ToolsStockUpdate",
  "View-SparesStockUpdate",
  "Notified Product List",
  "Spares Stock Management",
  "Tools Stock Management",
];

const InventoryTabs = () => {
  const [activeTab, setActiveTab] = useState("View-SparesStockUpdate");
  

 

  return (
   <div>
  {/* Tabs */}
  <div className="tabs">
    {tabs.map((tab) => (
      <button
        key={tab}
        className={`tab ${activeTab === tab ? "active" : ""}`}
        onClick={() => setActiveTab(tab)}
      >
        {tab}
      </button>
    ))}
  </div>


 

  {/* Other tabs */}
{activeTab === "Product List" && <ProductList />}
{activeTab === "View-ToolsStockUpdate" && <ViewStockToolsUpdate />}
{activeTab === "View-SparesStockUpdate" && <ViewSparesStockUpdate />}
{activeTab === "Notified Product List" && <NotifiedList />}
{activeTab === "Spares Stock Management" && <StockManagement />}
{activeTab === "Tools Stock Management" && <ToolsStockManagement />}


  {/* CSS for Tabs */}
  <style>
    {`
      /* Tabs container */
      .tabs {
        display: flex;
        gap: 20px;
        border-bottom: 1px solid #ddd;
        margin-bottom: 20px;
        font-family: Arial, sans-serif;
      }

      /* Tab links */
      .tab {
        padding: 8px 0;
        cursor: pointer;
        text-decoration: none;
        color: #000; /* teal-ish text color */
        font-size: 14px;
        font-weight: 500;
        border-bottom: 3px solid transparent;
        transition: all 0.2s ease-in-out;
        background: none;
        border: none;
      }

      /* Active tab underline */
      .tab.active {
        border-bottom: 3px solid #1890ff; /* blue underline */
        color: #1890ff;
      }

      /* Hover effect */
      .tab:hover {
        color: #1890ff;
      }
        
    `}
  </style>
</div>

  );
};

export default InventoryTabs;

